import { Component, inject, OnInit } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { Router, RouterOutlet } from '@angular/router'
import { AuthService } from '@auth0/auth0-angular'
import { FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { NgxPermissionsModule } from 'ngx-permissions'
import { MonitoringService } from './core/services/monitoring.service'
import { AppStore } from './core/app.store'
import { SystemService } from './core/services/system.service'

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgxPermissionsModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [MonitoringService],
})
export class AppComponent implements OnInit {
    #authService = inject(AuthService)
    #monitoringService = inject(MonitoringService)
    #systemService = inject(SystemService)
    #appStore = inject(AppStore)

    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas, far)
    }

    ngOnInit() {
        this.#authService.error$.subscribe((error: Error) => {
            if (error) {
                this.#monitoringService.logEvent('Auth0 Error', { error: error })
                this.#authService.loginWithRedirect()
            }
        })

        this.#systemService.getSystemInformation().subscribe({
            next: (system) => {
                this.#appStore.setSystem(system)
            },
        })
    }
}
